/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { first, filter } from 'lodash';
import { isEmptyValue, composeValidators } from '@blend/enterprise-components';
import { getPasswordRequirements } from 'blb-utils/password';
const emailRegex = /^\S*(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const emailValidator = value => {
  return emailRegex.test(value) ? undefined : 'Email should include the @ symbol and a domain name (ex: yourname@domain.com) with no trailing or leading spaces';
};
export const requiredEmailValidator = composeValidators(isEmptyValue('Please input a valid email.'), emailValidator);
export const optionalEmailValidator = value => value ? emailValidator(value) : undefined;
export const emptyPasswordValidator = isEmptyValue('Please input your password.');
export const strengthAndMatchValidator = (password, _ref) => {
  let {
    confirmedPassword
  } = _ref;
  const requirements = filter(getPasswordRequirements(password, confirmedPassword), {
    isMet: false
  });
  return requirements.length ? first(requirements)?.description : undefined;
};
export const emptyCheckboxValidator = isEmptyValue('This field is required.');